module.exports = __webpack_public_path__ + "static/media/Calendar.da01cc71.svg";